<template>
    <v-layout>
        <v-flex class="scroll-y">
            <template v-if="showedConvenzione == true">
                <v-flex xs1 class="ml-2 py-2" style="cursor: pointer;" @click="showedConvenzione = false">
                    <v-icon size="30">mdi-arrow-left</v-icon>
                </v-flex>
                <v-flex xs12 class="mt-1">
                    <icon-label icon="business" color="accent">{{ $t('convenzioni.label.dati_convenzione')
                    }}</icon-label>
                </v-flex>

                <v-layout row class="ml-1">
                    <v-flex xs6>
                        <text-field :label="$t('label.nome')" v-model="convenzione_mostrata.nome" required />
                    </v-flex>
                    <v-flex xs6>
                        <phone-field :label="$t('label.telefono')" v-model="convenzione_mostrata.telefono"
                            show-details />
                    </v-flex>
                </v-layout>

                <v-flex xs12 class="mt-4">
                    <icon-label icon="location_on" color="accent">{{ $t('label.indirizzo') }}</icon-label>
                </v-flex>

                <indirizzo-select class="ml-1 mb-3" :paese.sync="convenzione_mostrata.nazione"
                    :regione.sync="convenzione_mostrata.regione" :provincia.sync="convenzione_mostrata.provincia"
                    :comune.sync="convenzione_mostrata.comune" :cap.sync="convenzione_mostrata.cap"
                    :frazione.sync="convenzione_mostrata.frazione" :via.sync="convenzione_mostrata.via"
                    :numero-civico.sync="convenzione_mostrata.numero_civico" show-frazione required />
            </template>

            <data-table v-else :items="showDeleted ? convenzioni_disactive : convenzioni_active" :headers="[
                { text: $t('label.nome'), value: 'nome', sortable: true, width: 30 },
                { text: $t('label.telefono'), value: 'telefono', width: 20 },
                { text: $t('convenzioni.label.clienti_registrati'), value: 'numero_agricoltori', sortable: true, width: 20 },
                { text: $t('label.report_compilati'), value: 'numero_report', sortable: true, width: 30 }]"
                :width-auto="true" initial-sort="nome" :loading="loading" show-header-button :toggled.sync="showDeleted"
                @click:item="(convenzione) => (showDeleted ? showDeletedDialog(convenzione) : showEditDialog(convenzione))">

                <template slot="items" slot-scope="{item}">
                    <td>{{ item.nome }}</td>
                    <td>{{ $utils.formatPhone(item.telefono) }}</td>
                    <td>{{ item.numero_agricoltori }}</td>
                    <td>{{ item.numero_report }}</td>
                    <td>
                        <v-btn v-show="!showDeleted" icon small flat class="right"
                            @click.stop="showDeleteConfirmDialog(item.id)">
                            <v-icon>clear</v-icon>
                        </v-btn>
                    </td>
                </template>
            </data-table>

            <data-table v-if="showedConvenzione == true" :headers="[
                { text: $t('label.numero_attestato'), value: 'numero', width: 14 },
                { text: $t('label.data'), value: 'data_controllo', width: 14 },
                { text: $t('prenotazioni.label.marca'), value: 'marca', width: 16 },
                { text: $t('prenotazioni.label.modello'), value: 'modello', width: 14 },
                { text: $t('prenotazioni.label.telaio'), value: 'numero_serie', width: 14 },
                { text: $t('prenotazioni.label.scadenza'), value: 'scadenza', width: 14 },
                { text: $t('label.tecnico'), value: 'id_tecnico', width: 14 }]" :width-auto="true" :items="reports" :loading="loading"
                @click:item="showReportDialog">

                <template slot="items" slot-scope="{ item }">
                    <td>
                        <v-tooltip bottom>
                            <v-icon slot="activator" :color="item.compilato ? 'success' : 'error'">{{ item.compilato ?
                                'check_circle' : 'error' }}</v-icon>
                            <span>{{ item.compilato ? $t('reports.messaggi.compilato') :
                                $t('reports.messaggi.non_compilato') }}</span>
                        </v-tooltip>
                        <span class="ml-2" style="vertical-align: text-bottom">{{ item.numero }}</span>
                    </td>
                    <td>{{ $d($utils.date.toJs(item.data_controllo)) }}</td>
                    <td>{{ item.marca }}</td>
                    <td>{{ item.modello }}</td>
                    <td>{{ item.numero_serie }}</td>
                    <td>{{ item.scadenza }}</td>
                    <td colspan="2">{{ item.id_tecnico && getNomeCognomeById(item.id_tecnico) }}</td>
                </template>
            </data-table>

            <v-btn v-show="!showDeleted" color="accent" fixed right bottom round large class="mr-2"
                @click="showedConvenzione ? editConvenzione() : showCreateDialog()">
                <template v-if="!showedConvenzione">
                    <v-icon class="mr-2">add</v-icon>
                    {{ $t('azioni.aggiungi') }}
                </template>
                <template v-else>
                    {{ $t('convenzioni.azioni.modifica') }}
                </template>
            </v-btn>

            <report-dialog ref="reportDialog" />
            <convenzione-dialog ref="convenzioneDialog" @success="fetchData" />
            <convenzione-deleted-dialog ref="convenzioneDeletedDialog" @success="fetchData" />

        </v-flex>
    </v-layout>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import ConvenzioneDialog from '@/components/ConvenzioneDialog'
import ConvenzioneDeletedDialog from '@/components/ConvenzioneDeletedDialog'
import ReportDialog from '@/components/ReportDialog'
import { IndirizzoSelect, PhoneField } from '../../src/components/inputs'


export default {
    name: 'Convenzioni',
    components: { ConvenzioneDeletedDialog, ConvenzioneDialog, DataTable, ReportDialog, IndirizzoSelect, PhoneField },
    data: () => ({
        showDeleted: false,
        loading: false,
        convenzioni_active: [],
        convenzioni_disactive: [],
        reports: [],
        showedConvenzione: false,
        convenzione_mostrata: null,
    }),
    watch: {
        showDeleted: {
            handler: 'fetchData',
            immediate: true
        }
    },
    mounted() {
        //  Per evitare errori prima carico i dati dei tecnici
        this.loading = true
        Promise.all([
            this.$store.dispatch('loadTecnici')
        ]).then(() => {
            this.fetchData(1)
        }).catch(e => {
            this.$snackbar.showServerError(e)
            this.loading = false
        })
    },
    methods: {
        showCreateDialog() {
            this.$refs.convenzioneDialog.showCreate()
        },
        editConvenzione() {
            this.$api.convenzioni.update(this.convenzione_mostrata.id, new Date())
                .then(() => {
                    this.fetchData();
                }).catch(e => {
                    this.$snackbar.showServerError(e)
                })

            this.showedConvenzione = false;
        },
        async showEditDialog(convenzione) {
            this.convenzione_mostrata = JSON.parse(JSON.stringify(convenzione));
            await this.$api.reports.getFromConvenzione(convenzione.id)
                .then((res) => {
                    this.reports = res.data;
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('unita_mobili.errori.riferimenti_attivi'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })

            this.showedConvenzione = true;
            // this.$refs.convenzioneDialog.showEdit(convenzione)
        },
        showDeletedDialog(convenzione) {
            this.$refs.convenzioneDeletedDialog.show(convenzione)
        },
        showDeleteConfirmDialog(id) {
            this.$confirmDialog.show(id, this.$t('messaggi.conferma_eliminazione'), this.deleteConvenzione)
        },
        deleteConvenzione(id) {
            this.$api.convenzioni.delete(id)
                .then(response => {
                    this.$snackbar.show(this.$t('convenzioni.messaggi.eliminato'), 'success')
                    this.fetchData()
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('convenzioni.errori.riferimenti_attivi'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })
        },
        showReportDialog(report) {
            console.log(report)
            this.$refs.reportDialog.show(report, null, true);
        },
        getNomeCognomeById(id) {
            let tecnico = this.$store.getters.getTecnicoById(id);
            return tecnico ? tecnico.nome_cognome : '-';
        },
        action() {
            if (this.showDeleted) {
                return this.$api.convenzioni.getDeleted()
            } else {
                return this.$api.convenzioni.getAll()
            }
        },
        fetchData() {
            this.loading = true
            this.action()
                .then(response => {
                    this.convenzioni_active = [];
                    this.convenzioni_disactive = [];
                    this.loading = false
                    for (let c of response.data) {
                        if (c.attivo) {
                            this.convenzioni_active.push(c);
                        } else {
                            this.convenzioni_disactive.push(c);
                        }
                    }
                    // Viene forzato l'aggiornamento per i select convenzione
                    this.$store.commit('SET_CONVENZIONI', [])
                })
                .catch(e => {
                    this.$snackbar.showServerError(e)
                    this.loading = false
                })
        }
    }
}
</script>
